(() => {
  document.querySelectorAll('[data-camperspick-top]').forEach(root => {
    const gallery = root.querySelector('[data-pick-gallery]');
    const cards = [...gallery.querySelectorAll('[data-pick-item]')];
    const mobile = window.matchMedia('(max-width: 719px)');

    cards.sort((a, b) => {
      const aHasDate = Number(a.dataset.date || 0) > 0;
      const bHasDate = Number(b.dataset.date || 0) > 0;
      if (aHasDate !== bHasDate) return aHasDate ? 1 : -1;
      if (!aHasDate) return Number(b.dataset.id) - Number(a.dataset.id);
      const byDate = Number(b.dataset.date || 0) - Number(a.dataset.date || 0);
      return byDate || b.dataset.handle.localeCompare(a.dataset.handle);
    });
    gallery.replaceChildren(...cards);

    function render() {
      cards.forEach((card, index) => {
        const visible = index < (mobile.matches ? 4 : 10);
        card.hidden = !visible;
        if (visible) {
          const image = card.querySelector('img');
          if (!image.hasAttribute('src')) image.src = card.dataset.image;
        }
      });
    }

    mobile.addEventListener('change', render);
    render();
  });
})();
